import { axios } from "../lib/axios";

export const getAlignerMaterial = async function (alignerMaterialId) {
  try {
    const response = await axios.get("settings/getalignermaterial", {
      params: { alignerMaterialId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getAllAlignerMaterials = async function () {
  try {
    const response = await axios.get("settings/getallalignermaterials");
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addAlignerMaterial = async function (model) {
  try {
    const response = await axios.post("settings/addalignermaterial", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateAlignerMaterial = async function (model) {
  try {
    const response = await axios.post("settings/updatealignermaterial", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteAlignerMaterial = async function (model) {
  try {
    const response = await axios.delete("settings/deletealignermaterial", {
      data: model,
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
